// export enum DocumentType {
//   supplierInvoice = "ACCPAY"
// }

export enum DocumentType {
  "Supplier Invoice" = "ACCPAY",
  "Customer Invoice" = "ACCREC",
  "Credit Note"="ACCPAYCREDIT",
  "Expense Claim" = "EXPCLAIMS",
  "Receipt" ="EXP"
}
